import React, { useState, useEffect } from "react";
import BusinessTile from "./BusinessTile";
import { YelpBusiness, YelpResult } from "../lib/yelp";

const Results: React.FC = ({ yelpResults }: { yelpResults: YelpResult }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageItems, setPageItems] = useState<YelpBusiness[]>(
    yelpResults.businesses
  );
  const itemsPerPage = 10;

  const handleNextPage = async () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      // Slice yelpResults to get the next page
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const nextPageItems = yelpResults.businesses.slice(startIndex, endIndex);
      setPageItems(nextPageItems);
    }
  };

  const handlePreviousPage = async () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      // Slice yelpResults to get the previous page
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const previousPageItems = yelpResults.businesses.slice(
        startIndex - itemsPerPage,
        endIndex - itemsPerPage
      );
      setPageItems(previousPageItems);
    }
  };

  useEffect(() => {
    setPageItems(yelpResults.businesses);
    setCurrentPage(1);
    setTotalPages(Math.ceil(yelpResults.total / itemsPerPage));
  }, [yelpResults]);

  return (
    <div className="flex flex-wrap gap-4 mt-4 w-full">
      {pageItems.map((business) => (
        <BusinessTile key={business.id} business={business} />
      ))}
      {pageItems.length > 0 && (
        <div className="flex justify-center w-full mt-4">
          <button
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
            className="px-4 py-2 mx-2 text-blue-500 hover:text-blue-600 disabled:opacity-50"
          >
            Previous
          </button>
          <span className="px-4 py-2">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className="px-4 py-2 mx-2 text-blue-500 hover:text-blue-600 disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Results;
